import { createBrowserRouter } from 'react-router-dom';
import { AppContent } from '../AppContent';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppContent />,
    loader: () => ({ view: 'main' }),
  },
  {
    path: '/upload',
    element: <AppContent />,
    loader: () => ({ view: 'upload' }),
  },
  {
    path: '/flashcards',
    element: <AppContent />,
    loader: () => ({ view: 'flashcards' }),
  },
  {
    path: '/quizzes',
    element: <AppContent />,
    loader: () => ({ view: 'quizzes' }),
  },
  {
    path: '/quizzes/:quizId',
    element: <AppContent />,
    loader: ({ params }) => ({ view: 'quiz-detail', quizId: params.quizId }),
  },
  {
    path: '/quizzes/:quizId/take',
    element: <AppContent />,
    loader: ({ params }) => ({ view: 'quiz-take', quizId: params.quizId }),
  },
  {
    path: '/quizzes/:quizId/results',
    element: <AppContent />,
    loader: ({ params }) => ({ view: 'quiz-results-history', quizId: params.quizId }),
  },
  {
    path: '/quizzes/:quizId/results/:quizResultId',
    element: <AppContent />,
    loader: ({ params }) => ({ view: 'quiz-result-detail', quizId: params.quizId, resultId: params.quizResultId }),
  },
]);